
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
};


export function clamp01(value) {
    return clamp(value, 0, 1);
};


export function lerp(v0, v1, t, clamp) {
    if (clamp) t = Math.max(0, Math.min(1, t));
    var v = v0 + (v1 - v0) * t;
    return v;
}

export function lerpInv(v0, v1, v, clamp) {
    var t = (v - v0) / (v1 - v0);
    if (clamp) t = Math.max(0, Math.min(1, t));
    return t;
}